// extracted by mini-css-extract-plugin
module.exports = {"container":"MetricsUsagePoints-module__container__G6iar"};